import React, { useState } from 'react';

function Input({ config, onFocus, onChange }, ref) {
  const [value, setValue] = useState(config.defaultValue);

  function onChangeHandle(event) {
    const val = event.target.value;

    setValue(val);

    if(config.name) {
      onChange(val);
    }
  }

  return (
    <input
      type="text"
      value={value}
      name={config.name}
      placeholder={config.customProps?.placeholder || "请输入"}
      onChange={onChangeHandle}
      onFocus={onFocus}
    />
  );
}

export default React.forwardRef(Input);
